var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareFeedback(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0.875C19.9353 0.875 20.3168 1.03946 20.6387 1.36133C20.9605 1.68319 21.125 2.06468 21.125 2.5V15.5C21.125 15.9353 20.9605 16.3168 20.6387 16.6387C20.3168 16.9605 19.9353 17.125 19.5 17.125H5.05273L1.08887 21.0889L0.875 21.3018V2.5C0.875 2.06468 1.03946 1.68319 1.36133 1.36133C1.68319 1.03946 2.06468 0.875 2.5 0.875H19.5ZM2.625 17.1797L4.25781 15.415L4.29492 15.375H19.375V2.625H2.625V17.1797ZM11.1152 4.20117L12.4102 7.28125L15.7598 7.55078L16.0576 7.57422L15.832 7.76953L13.2881 9.96973L14.0469 13.2217L14.1143 13.5107L13.8604 13.3564L11 11.6211L8.13965 13.3564L7.88574 13.5107L7.95312 13.2217L8.71094 9.96973L6.16797 7.76953L5.94238 7.57422L6.24023 7.55078L9.58887 7.28125L10.8848 4.20117L11 3.92773L11.1152 4.20117Z",
    fill: "#004E98",
    stroke: "#004E98",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareFeedback);
export default __webpack_public_path__ + "static/media/share-feedback.4ab56e81dfbfcb7372441ab98764070d.svg";
export { ForwardRef as ReactComponent };